/**
 * @file コンポーネント：フル動画ページポイントコンテンツ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Button } from "~/src/components/uiparts/Button";
import { Slider } from "~/src/components/uiparts/Slider";

// 関数読み込み
import { fnConvertLineStringToHtml } from "~/src/functions/common";

// スタイル読み込み
import {
    StyledContent,
    StyledContentHeadline,
    StyledContentParagraph,
    StyledContentSection,
    StyledContentSectionContainer,
    StyledContentSlider,
    StyledContentSliderImage,
    StyledContentText,
    StyledContentTextLink,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    return (
        <StyledContent>
            {props.listPointcontents.map((content, index) => (
                <StyledContentSection key={"point-" + index}>
                    <StyledContentHeadline>
                        {content.pointTitle}
                    </StyledContentHeadline>
                    <StyledContentSectionContainer>
                        {content.pointContentsImageList.length > 0 && (
                            <StyledContentSlider>
                                <Slider
                                    arrows={true}
                                    defaultIndex={content.currentIndexSlide}
                                    dots={true}
                                    list={content.pointContentsImageList.map(
                                        (image, i) => (
                                            <StyledContentSliderImage
                                                alt=""
                                                key={"slide-" + i}
                                                src={image.contentUrl}
                                            />
                                        )
                                    )}
                                    zoom={true}
                                />
                            </StyledContentSlider>
                        )}
                        <StyledContentText>
                            <StyledContentParagraph
                                dangerouslySetInnerHTML={{
                                    __html: fnConvertLineStringToHtml(
                                        content.pointContext
                                    ),
                                }}
                            />
                            {content.pointTime && (
                                <StyledContentTextLink>
                                    <Button
                                        buttonType="accent"
                                        dummyDisabled={
                                            props.isEditPage !== true &&
                                            props.isPaid === true &&
                                            props.isPurchased === false
                                        }
                                        href="#"
                                        onClick={(e) =>
                                            props.fnClickButtonJump(
                                                e,
                                                content.pointTime
                                            )
                                        }
                                        text={
                                            localized["Label.PlayThisPoint"] +
                                            " (" +
                                            content.pointTime +
                                            ")"
                                        }
                                    />
                                </StyledContentTextLink>
                            )}
                        </StyledContentText>
                    </StyledContentSectionContainer>
                </StyledContentSection>
            ))}
        </StyledContent>
    );
};
